

























































import ExercisesFormInput from '@/components/exercises/forms/ExercisesFormInput.vue'
import ExercisesFormGroupFeedback from '@/components/exercises/forms/ExercisesFormGroupFeedback.vue'
import ExercisesFormGroupComments from '@/components/exercises/forms/ExercisesFormGroupComments.vue'
import { withDefault, withUnit } from '@/components/exercises/measure/filters'

export default {
  components: {
    ExercisesFormInput,
    ExercisesFormGroupFeedback,
    ExercisesFormGroupComments,
  },
  filters: {
    withDefault,
    withUnit,
  },
  props: {
    strengtheningExercise: {
      type: Object,
      required: true,
      validator: obj =>
        ['exerciseName', 'reps', 'feedbackRating', 'feedbackMoreWorkLoad', 'comments'].every(key => key in obj),
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
  },
}
